
import {
  SHOW_ONLINETEST_RESULT_FAIELD,
  SHOW_ONLINETEST_RESULT_REQUIST,
  SHOW_ONLINETEST_RESULT_SUCCESS,
} from "../../Constants/MockTest/OnlineTest";

const initialState = {
  loading: false,
  result: [],
};
export const OnlineTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ONLINETEST_RESULT_REQUIST:
      return {
        ...state,
        loading: true,
      };
    case SHOW_ONLINETEST_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload,
      };

    case SHOW_ONLINETEST_RESULT_FAIELD:
      return {
        ...state,
        loading: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
